import { CommonModule, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Routing } from './app.routes';

// Jwt Module
import { JwtModule } from '@auth0/angular-jwt';
export function tokenGetter() {
  return window.localStorage.getItem('tk');
}

// ngx Toastr - toaster
import { ToastrModule } from 'ngx-toastr';

// Components
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';

// Services
import { AnalyticsService, AuthenticationService, FileDownloadService } from './core/services';

// Helpers
import { ScBrowserDetectHelper } from 'app/core/helpers/sc-browser-detect.helper';
import { ScFormHelper } from './core/helpers/sc-form.helper';

// Modules
import { ScModalDialogModule, UiCoreComponentsModule } from '@sc/claim-components';
import { ScDropdownModule } from 'app/shared/components/sc-dropdown/sc-dropdown.module';
import { ScNotificationsModule } from 'app/shared/components/sc-notifications/sc-notifications.module';
import { ScPipesModule } from 'app/shared/pipes/sc-pipes.module';
import { ScHeaderInfoModule } from './components/header-info/header-info.module';
import { CoreModule } from './core/core.module';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);

// Modals
import {
  ScDownloadBaremoModalModule,
  ScNewsModalModule,
  ScServiceAgreementModalModule,
  ScVersionsModalModule
} from 'app/shared/components/sc-modals';

import { GalleryModule } from '@ks89/angular-modal-gallery';

import localEs from '@angular/common/locales/es';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireRemoteConfigModule } from '@angular/fire/compat/remote-config';
import { environment } from 'environments/environment';
import { getEnvironment } from 'environments/loadEnvironment.factory';
import { firstValueFrom } from 'rxjs';
import { FeatureToggleService } from './core/services/feature-toggle.service';
import { ScTableModule } from './shared/components/sc-table/sc-table.module';
registerLocaleData(localEs);

const env = getEnvironment();

export function initApp(featureToggleService: FeatureToggleService) {
  return () => firstValueFrom(featureToggleService.getFeaturesByUsername());
}

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    Routing,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    GalleryModule,
    ScPipesModule,
    UiCoreComponentsModule,
    ScServiceAgreementModalModule,
    ScNewsModalModule,
    ScDownloadBaremoModalModule,
    ScVersionsModalModule,
    ScHeaderInfoModule,
    ScDropdownModule,
    ScNotificationsModule,
    ScTableModule,
    ScModalDialogModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(env.firebase),
    AngularFireRemoteConfigModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: 'envConfig', useValue: { environment } },
    provideAppInitializer(() => {
        const initializerFn = (initApp)(inject(FeatureToggleService));
        return initializerFn();
      }),
    AnalyticsService,
    AuthenticationService,
    ScBrowserDetectHelper,
    ScFormHelper,
    FileDownloadService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
